function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_79373",
  "data-name": "Group 79373",
  transform: "translate(-306 -88)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_79372",
  "data-name": "Group 79372",
  transform: "translate(6 4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "np_minimize_5540502_000000",
  d: "M19.441,35.442a16,16,0,0,1-16-16,16.24,16.24,0,0,1,2.824-9.077A15.183,15.183,0,0,1,8.127,8.128,16,16,0,1,1,19.441,35.442Z",
  transform: "translate(296.559 80.559)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "np_minimize_5540502_000000-2",
  "data-name": "np_minimize_5540502_000000",
  d: "M17.549,21.92a1.675,1.675,0,0,0-1.675-1.676H12.579A1.675,1.675,0,0,0,10.9,21.92v3.294a1.679,1.679,0,0,0,1.678,1.678h3.295a1.675,1.675,0,0,0,1.675-1.678Zm9.119-10.742a.82.82,0,0,0-1.16,0l-5.692,5.678V13.28h0a.821.821,0,0,0-1.642,0v5.553a.821.821,0,0,0,.822.82h5.556a.821.821,0,0,0,0-1.642H20.975l5.692-5.692a.819.819,0,0,0,0-1.146Z",
  transform: "translate(297.099 81.085)",
  fill: "#010a14"
})));

function SvgMinimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.67ecfa15.svg";
export { ForwardRef as ReactComponent };